export class DsoSessionMessage {
  private type: string;
  private data: any;

  constructor({ type, data }: { type: string; data: any }) {
    this.type = type;
    this.data = data;
  }
}
